import { createContext, type PropsWithChildren, useContext } from 'react'
import type { DialogState } from 'ariakit'
import { useModalState } from '@vtex/admin-ui'
import { InactiveItemModal } from '@/components/products-listing/InactiveItemModal/InactiveItemModal'

type InactiveItemModalContextValue = DialogState

const InactiveItemModalContext =
  createContext<InactiveItemModalContextValue | null>(null)

export const InactiveItemModalProvider = ({ children }: PropsWithChildren) => {
  const inactiveItemModalState = useModalState()

  return (
    <>
      <InactiveItemModalContext.Provider value={inactiveItemModalState}>
        {children}
      </InactiveItemModalContext.Provider>
      <InactiveItemModal state={inactiveItemModalState} />
    </>
  )
}

export const useInactiveItemModal = () => {
  const context = useContext(InactiveItemModalContext)

  if (!context) {
    throw new Error(
      'useInactiveItemModal must be used within an InactiveItemModalProvider'
    )
  }

  return context
}
